<i [attr.data-feather]="name"></i>